"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const Button_1 = require("./Button");
const colors_1 = require("../styles/colors");
const typography_1 = require("../styles/typography");
class NavBar extends React.Component {
    constructor(props) {
        super(props);
    }
    componentDidUpdate() {
        if (this.props.id) {
            this.props.getElement(document.getElementsByClassName('popper')[0].dataset.placement, document.getElementById(this.props.id).style.height);
        }
    }
    render() {
        let { buttonLeft, title, buttonRight, style, id, buttonLeftCallback, buttonRightCallback, customLeftElem, customRightElem, customTitleElem, } = this.props;
        const container = Object.assign({ background: colors_1.cloud, height: 56, width: '100%', display: 'flex' }, style.containerStyle);
        let buttonLeftStyle = Object.assign({ outerStyle: {
                marginLeft: 16,
            } }, style.buttonLeftStyle);
        const buttonRightStyle = Object.assign({ outerStyle: {
                marginRight: 16,
            } }, style.buttonRightStyle);
        let innerStyle = {
            flex: 1,
            display: 'flex',
            alignItems: 'center',
            whiteSpace: 'nowrap',
        };
        const renderLeftNavbar = () => {
            if (customLeftElem) {
                return customLeftElem;
            }
            else {
                return React.createElement(Button_1.default, { text: buttonLeft, type: "regular", style: buttonLeftStyle, onClick: buttonLeftCallback });
            }
        };
        const renderRightNavbar = () => {
            if (customRightElem) {
                return customRightElem;
            }
            else {
                return (React.createElement(Button_1.default, { text: buttonRight, type: "regular", style: Object.assign({}, buttonRightStyle), onClick: buttonRightCallback }));
            }
        };
        return (React.createElement("div", { style: container, id: id },
            React.createElement("div", { style: Object.assign({}, innerStyle) }, renderLeftNavbar()),
            React.createElement("div", { style: Object.assign({}, typography_1.text, typography_1.medium, innerStyle, { flex: 2, justifyContent: 'center', color: colors_1.charcoal }, style.titleStyle) }, customTitleElem ? customTitleElem : title),
            React.createElement("div", { style: Object.assign({}, innerStyle, { justifyContent: 'flex-end' }) }, renderRightNavbar())));
    }
}
NavBar.defaultProps = {
    style: {
        containerStyle: {},
        buttonLeftStyle: {},
        buttonRightStyle: {},
        titleStyle: {},
    },
};
exports.default = NavBar;
